// frontend/src/mocks/reinsurance/dashboardData.js

export const mockDashboardData = {
  success: true,
  data: {
    report_date: "2025-05-03T10:30:00Z",
    contract_metrics: {
      total_contracts: 42,
      total_limit: 630000000,
      total_premium: 94500000,
      average_limit: 15000000,
      average_premium: 2250000,
      contracts_by_type: {
        property: {
          count: 25,
          total_limit: 375000000,
          total_premium: 56250000
        },
        specialty: {
          count: 10,
          total_limit: 150000000,
          total_premium: 22500000
        },
        parametric: {
          count: 5,
          total_limit: 75000000,
          total_premium: 11250000
        },
        ilw: {
          count: 2,
          total_limit: 30000000,
          total_premium: 4500000
        }
      },
      contracts_by_status: {
        active: {
          count: 35,
          total_limit: 525000000,
          total_premium: 78750000
        },
        bound: {
          count: 5,
          total_limit: 75000000,
          total_premium: 11250000
        },
        draft: {
          count: 2,
          total_limit: 30000000,
          total_premium: 4500000
        }
      }
    },
    capital_metrics: {
      total_capital: 100000000,
      total_allocated: 75000000,
      total_available: 25000000,
      allocation_percentage: 75,
      capital_by_investor_type: {
        ils_fund: {
          count: 3,
          total_capital: 40000000,
          total_allocated: 30000000,
          total_available: 10000000
        },
        pension_fund: {
          count: 2,
          total_capital: 30000000,
          total_allocated: 22500000,
          total_available: 7500000
        },
        reinsurer: {
          count: 1,
          total_capital: 20000000,
          total_allocated: 15000000,
          total_available: 5000000
        },
        hedge_fund: {
          count: 1,
          total_capital: 10000000,
          total_allocated: 7500000,
          total_available: 2500000
        }
      }
    },
    claim_metrics: {
      total_claims: 7,
      total_incurred: 18750000,
      total_paid: 9375000,
      total_reserved: 9375000,
      claims_by_status: {
        in_process: {
          count: 5,
          total_incurred: 12500000,
          total_paid: 6250000,
          total_reserved: 6250000
        },
        reported: {
          count: 2,
          total_incurred: 6250000,
          total_paid: 3125000,
          total_reserved: 3125000
        }
      },
      claims_by_event_type: {
        hurricane: {
          count: 3,
          total_incurred: 10000000,
          total_paid: 5000000,
          total_reserved: 5000000
        },
        wildfire: {
          count: 2,
          total_incurred: 5000000,
          total_paid: 2500000,
          total_reserved: 2500000
        },
        earthquake: {
          count: 1,
          total_incurred: 2500000,
          total_paid: 1250000,
          total_reserved: 1250000
        },
        flood: {
          count: 1,
          total_incurred: 1250000,
          total_paid: 625000,
          total_reserved: 625000
        }
      }
    },
    recentContracts: [
      { 
        contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f", 
        contract_number: "RIL-240315-789", 
        rnr: "RNR5A3F2",
        cedent: { cedent_name: "Global Insurance Co." }, 
        contract_type: "property", 
        contract_structure: "non_proportional",
        terms: {
          effective_date: "2025-01-01T00:00:00Z",
          expiration_date: "2025-12-31T23:59:59Z",
          limit: 15000000,
          premium: { base_amount: 2250000 }
        },
        performance: { current_status: "active" } 
      },
      { 
        contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p", 
        contract_number: "RIL-240422-456", 
        rnr: "RNR7B2D9",
        cedent: { cedent_name: "Pacific Mutual" }, 
        contract_type: "specialty", 
        contract_structure: "proportional",
        terms: {
          effective_date: "2025-02-15T00:00:00Z",
          expiration_date: "2026-02-14T23:59:59Z",
          limit: 10000000,
          premium: { base_amount: 1500000 }
        },
        performance: { current_status: "active" } 
      },
      { 
        contract_id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p", 
        contract_number: "RIL-240501-123", 
        rnr: "RNR3K9P7",
        cedent: { cedent_name: "Atlantic Re" }, 
        contract_type: "parametric", 
        contract_structure: "hybrid",
        terms: {
          effective_date: "2025-03-01T00:00:00Z",
          expiration_date: "2026-02-28T23:59:59Z",
          limit: 20000000,
          premium: { base_amount: 3000000 }
        },
        performance: { current_status: "bound" } 
      }
    ],
    recentClaims: [
      { 
        claim_id: "d1e2f3g4-h5i6-j7k8-l9m0-n1o2p3q4r5s6", 
        claim_number: "CLM-250412-001", 
        contract_number: "RIL-240315-789", 
        event: { 
          event_name: "Hurricane Milton", 
          event_date: "2025-04-10T00:00:00Z",
          event_type: "hurricane"
        }, 
        financials: { 
          incurred_loss: 3500000,
          paid_to_date: 1750000,
          current_reserve: 1750000,
          currency: "USD"
        }, 
        status: { 
          current_status: "in_process",
          reported_date: "2025-04-12T10:15:00Z"
        } 
      },
      { 
        claim_id: "t7u8v9w0-x1y2-z3a4-b5c6-d7e8f9g0h1i2", 
        claim_number: "CLM-250428-002", 
        contract_number: "RIL-240422-456", 
        event: { 
          event_name: "California Wildfire 2025", 
          event_date: "2025-04-25T00:00:00Z",
          event_type: "wildfire"
        }, 
        financials: { 
          incurred_loss: 2800000,
          paid_to_date: 0,
          current_reserve: 2800000,
          currency: "USD"
        }, 
        status: { 
          current_status: "reported",
          reported_date: "2025-04-28T14:30:00Z"
        } 
      }
    ]
  }
};